<template>
  <div class="teen-page teen7">
    <div class="header">
      <h1>兵马俑：地下的军团</h1>
    </div>

    <div class="container">
      <div class="img-box">
        <img src="https://img.moliaos.com/v/teen/teen_7.png" alt="兵马俑">
        <div class="caption">秦始皇兵马俑，世界第八大奇迹</div>
      </div>

      <h2>一、 发现之旅</h2>
      <p>1974年，陕西临潼的农民在打井时偶然发现了兵马俑坑。这一发现震惊了世界，被誉为"世界第八大奇迹"。兵马俑是秦始皇陵的陪葬坑，展示了秦朝强大的军事力量。</p>

      <h2>二、 规模宏大</h2>
      <p>兵马俑坑共有三个坑，总面积达2万多平方米。已出土的兵马俑超过8000件，包括士兵、战马、战车等。每个兵马俑都栩栩如生，表情、服饰各不相同，展现了古代工匠的高超技艺。</p>

      <div class="img-box">
        <img src="https://img.moliaos.com/v/teen/teen_7.png" alt="兵马俑特写">
        <div class="caption">兵马俑面部特写，每个都有独特的表情</div>
      </div>

      <h2>三、 制作工艺</h2>
      <p>兵马俑采用模塑结合的方法制作，先用陶模做出初胎，再进行精细雕刻。烧制完成后，还会进行彩绘。虽然大部分彩绘已经脱落，但仍能看出当时的色彩斑斓。</p>

      <h2>四、 历史价值</h2>
      <p>兵马俑不仅是精美的艺术品，更是研究秦朝历史的珍贵资料。它们展示了秦朝的军事编制、武器装备、服饰风格等，为我们了解古代中国提供了重要线索。</p>

      <div class="quote-box">
        "世界上有七大奇迹，秦俑的发现可以说是第八大奇迹。" —— 希拉克
      </div>

      <h2>五、 保护与传承</h2>
      <p>兵马俑的保护是一项艰巨的任务。由于年代久远，许多兵马俑出土后会出现开裂、褪色等问题。文物工作者采用先进技术进行保护，让这些珍贵的遗产能够长久保存。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Teen7'
}
</script>

<style scoped>
.teen-page {
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  margin: 0;
  background: #f8f4e8;
  line-height: 1.8;
}

.header {
  background: linear-gradient(135deg, #8b7355 0%, #a08060 100%);
  color: white;
  padding: 30px 20px;
  text-align: center;
}

.container {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
}

h1 {
  margin: 0;
  font-size: 1.6rem;
}

h2 {
  color: #5d4e37;
  border-bottom: 2px solid #8b7355;
  padding-bottom: 8px;
  margin-top: 30px;
  font-size: 1.2rem;
}

p {
  text-indent: 2em;
  margin-bottom: 20px;
  text-align: justify;
}

.img-box {
  text-align: center;
  margin: 25px 0;
}

.img-box img {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
}

.caption {
  font-size: 0.85rem;
  color: #666;
  margin-top: 10px;
}

.quote-box {
  background: #f5efe6;
  padding: 20px;
  border-left: 4px solid #8b7355;
  margin: 25px 0;
  font-style: italic;
  color: #333;
}
</style>